import { trackEvent } from './tracking';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

export const usePITracking = () => {
  const { app } = useApp();
  const appId = app.id;
  const { user, id: currentUserId } = useCurrentUser();
  const currentPiUserId = user.piUserGuid;

  const trackPIEvent = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      app_id: appId,
      user: currentUserId,
      pi_user: currentPiUserId,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackLinkToPIClick = ({ source }) => {
    trackPIEvent({
      eventName: 'Clicked to Navigate to PI',
      properties: { source: source },
    });
  };

  const trackLearnMoreInspireBasicsClick = () => {
    trackPIEvent({
      eventName: 'Clicked to Learn More PI Inspire Basics',
    });
  };

  const trackContactSales = ({ component }: { component: string }) => {
    trackPIEvent({
      eventName: 'Clicked to Contact Sales',
      properties: { component },
    });
  };

  return {
    trackPIEvent,
    trackLinkToPIClick,
    trackLearnMoreInspireBasicsClick,
    trackContactSales,
  };
};
